// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__aHy9B","plus":"styles_plus__yBwrj","key":"styles_key__rr10n"};